import React from 'react';

import { BaseIconProps } from '.';

export const ArrowPointingToTop = ({ fill }: BaseIconProps) => (
  <path
    fill={fill}
    d="m223.94345,558.03839l240.04132,-236.21752l0,763.00292l170.72907,0l0,-755.5655l240.04132,236.21752l120.73123,-118.87157l-447.65511,-444.9738l-444.61906,437.59994l120.73123,118.808z"
  />
);
